import { useEffect, useState } from "react";
import {
    BlogArticle,
    BlogArticlePreview,
    DefaultApi,
    Language,
} from "../adapters/api";
import { useTranslation } from "react-i18next";

export const useBlog = (blogId?: number) => {
    const defaultApi = new DefaultApi();

    const [blog, setBlog] = useState<BlogArticlePreview[]>([]);
    const [blogPost, setBlogPost] = useState<BlogArticle>();
    const [blogMorePost, setBlogMorePost] = useState<BlogArticlePreview[]>([]);
    const { t, i18n } = useTranslation();

    const getBlog = async (): Promise<BlogArticlePreview[]> =>
        new Promise((resolve, reject) => {
            defaultApi
                .getBlogHome(i18n.resolvedLanguage as Language)
                .then((response) => {
                    const { data } = response;
                    setBlog(data);
                    if (blogId) {
                        setBlogMorePost(
                            data
                                .reverse()
                                .filter((post) => post.id !== blogId)
                                .slice(0, 3)
                        );
                    }
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    const getBlogByArticleId = async (articleId: number): Promise<BlogArticle> =>
        new Promise((resolve, reject) => {
            defaultApi
                .getBlogArticle(articleId, i18n.resolvedLanguage as Language)
                .then((response) => {
                    const { data } = response;
                    setBlogPost(data);
                    resolve(data);
                })
                .catch((e) => {
                    reject(e);
                });
        });

    useEffect(() => {
        
        if (blogId) {
            getBlogByArticleId(blogId);
            getBlog();
        } else {
            getBlog();
        }
        // eslint-disable-next-line
    }, [blogId, t]);

    return {
        getBlog,
        getBlogByArticleId,
        blog,
        blogPost,
        blogMorePost,
    };
};
